import { object, string, number, array, boolean, mixed } from 'yup';

const numberErrorMessage = 'This field is must be numerical';

export const ROLES_PATHS_SCHEMA = object({
	course_id: number().notRequired(),
	progress_percentage: number()
		.typeError(numberErrorMessage)
		.min(0, 'Minimum at least 0')
		.max(100, 'Allowed maximum is 100')
		.nullable()
		.transform((value) => (value ? value : null)),
	sequential_units: boolean(),
	progress_criteria: string(),
	prerequisite_criteria: string(),
	units: array().of(number().min(1)),
	// The prerequisites form field is only a dirty-flag: PrerequisitePath
	// writes scalar option values into it, and the save handlers rebuild the
	// real prerequisites array from the paths state before submitting. Typing
	// it array() made validation fail on that scalar and silently swallow
	// every submit of the Roles & Paths forms.
	prerequisites: mixed().notRequired(),
});
